import { TabularTypeSettings } from 'app/model/dataflow/dataset-settings/tabular-type-settings';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.quickbase.dataflowSettings
})
export class QuickbaseSettings extends TabularTypeSettings {
    public getDatasetType(): string {
        // for now, Quickbase only support inline mode, it does not have dataset
        return undefined;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Quickbase;
    }

    public getIconClass(): string {
        return 'i-100x100-quickbase';
    }

    public getSubFormat(): string {
        return undefined;
    }
}
